import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useFulfillmentPlannerContext } from '../context';
import { UNSUPPORTED_DESTINATION } from '../../enums/insurance-providers';

import { InsuranceOptionContainer } from './container';
import { InsuranceOptionLabel } from './label';
import { InsuredAmountContainer } from '../insured-amount/container';
import { InsuredAmountLabel } from '../insured-amount/label';
import { InlineMessage } from 'ui-components/components/inline-message';

import { messages } from './messages';
import style from './style.module.css';

export const InsuranceDropdownWithLabel = ({ fulfillmentPlanId, insuranceOptions, isPartOfInsurancePromoExperiment = false }) => {
  const { hasInsuranceProviderSelected, rateErrors } = useFulfillmentPlannerContext();
  const containsSupportedDestinationError = rateErrors?.find((error) => error.length && error.includes(UNSUPPORTED_DESTINATION));

  return (
    <React.Fragment>
      <div className={style.label}>
        <InsuranceOptionLabel />
      </div>
      <InsuranceOptionContainer
        fulfillmentPlanId={fulfillmentPlanId}
        insuranceOptions={insuranceOptions}
        isPartOfInsurancePromoExperiment={isPartOfInsurancePromoExperiment}
      />
      <div />
      {containsSupportedDestinationError && (
        <InlineMessage className={style.alert}>
          <FormattedMessage {...messages.insuranceNotAvailable} />
        </InlineMessage>
      )}
      {hasInsuranceProviderSelected && !containsSupportedDestinationError && (
        <React.Fragment>
          <div className={style.label}>
            <InsuredAmountLabel />
          </div>
          <InsuredAmountContainer className={style['insurance-amount']} />
          <div />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

InsuranceDropdownWithLabel.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  insuranceOptions: PropTypes.array.isRequired,
  isPartOfInsurancePromoExperiment: PropTypes.bool,
};
